import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Package, PackageBox, PackageBoxShimmer } from "src/components";
import { _ } from "src/services";
import { Packages as PackagesState, PackagesAction } from "src/store";

export const Packages: React.FC = () => {

    //#region dependencies

    const dispatch = useDispatch();
    const packages: PackagesState = useSelector((state: any) => state.PackagesState);

    //#endregion

    //#region effects

    useEffect(() => {
        if (!packages.packageListLoaded) {
            dispatch(PackagesAction.requestPackages(false));
        }
    }, [dispatch, packages.packageListLoaded]);

    //#endregion

    const reload = () => {
        dispatch(PackagesAction.requestPackages(true));
    };

    return (
        <div className="page-packages app-theme2 pb-5">
            <div className="cover d-flex">
                <div className="container large-container d-flex text-center">
                    <h1>
                        <Package size={40} />
                        <span>{_("packagesPageTitle")}</span>
                    </h1>
                    <h2>{_("antenPackagesDescription")}</h2>
                </div>
            </div>
            <div className={`packages container large-container d-flex${!packages.loading && packages.packages.length <= 1 ? " justify-content-center one-package" : ""}`}>
                {
                    packages.loading && !packages.packageListLoaded && [...new Array(3)].map((x, index) => <PackageBoxShimmer key={index} />)
                }
                {packages.packages.map((p, index) => (
                    <PackageBox  {...p} key={index} />
                ))}
                {
                    packages.packageListLoaded && !packages.packages.length &&
                    <div className="package-box d-flex flex-column lonely">
                        <div className="header d-flex align-items-center">
                            <span>{_("noPackageTitle")}</span>
                        </div>
                        <ul className="description">
                            {
                                _("noPackageDescription").split("\n\r").map((x) => (
                                    x.split("\\n\\r").map((y, index) => (
                                        <li key={index}>{y}</li>
                                    ))
                                ))
                            }
                        </ul>
                        <span className="btn btn-submit" onClick={reload}>{_("reload")}</span>
                    </div>
                }
            </div>
        </div>
    );
};